import React, { useEffect, useState } from 'react';
import { Modal } from '../shared/Modal';
import { PicklistOption } from '../../types/metadata';
interface PicklistOptionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (option: PicklistOption | Omit<PicklistOption, 'id'>) => void;
  initialData?: PicklistOption;
  questionKey: string;
}
export function PicklistOptionModal({
  isOpen,
  onClose,
  onSave,
  initialData,
  questionKey
}: PicklistOptionModalProps) {
  const [formData, setFormData] = useState<Partial<PicklistOption>>({
    questionKey: questionKey,
    optionLabel: '',
    optionValue: '',
    order: 1,
    active: true
  });
  useEffect(() => {
    if (initialData && isOpen) {
      setFormData(initialData);
    } else if (isOpen) {
      setFormData({
        questionKey: questionKey,
        optionLabel: '',
        optionValue: '',
        order: 1,
        active: true
      });
    }
  }, [initialData, isOpen, questionKey]);
  const handleLabelChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const label = e.target.value;
    setFormData(prev => ({
      ...prev,
      optionLabel: label,
      optionValue: !initialData && (!prev.optionValue || prev.optionValue === prev.optionLabel?.replace(/\s+/g, '')) ? label.replace(/\s+/g, '') : prev.optionValue
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.optionLabel || !formData.optionValue || !formData.questionKey) return;
    onSave(formData as PicklistOption | Omit<PicklistOption, 'id'>);
    onClose();
  };
  const footer = <>
      <button type="button" onClick={onClose} className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50" data-id="element-242">
        Cancel
      </button>
      <button type="submit" form="picklist-option-form" className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700" data-id="element-243">
        {initialData ? 'Save Changes' : 'Add Option'}
      </button>
    </>;
  return <Modal isOpen={isOpen} onClose={onClose} title={initialData ? 'Edit Option' : 'New Option'} size="md" footer={footer} data-id="element-244">
      <form id="picklist-option-form" onSubmit={handleSubmit} className="space-y-5" data-id="element-245">
        <div data-id="element-246">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-247">
            Question Key
          </label>
          <input type="text" disabled value={formData.questionKey || ''} className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-100 text-gray-500 sm:text-sm font-mono" data-id="element-248" />
        </div>

        <div data-id="element-249">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-250">
            Option Label <span className="text-red-500" data-id="element-251">*</span>
          </label>
          <input type="text" required value={formData.optionLabel || ''} onChange={handleLabelChange} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500 sm:text-sm" placeholder="e.g., Single Family Detached" data-id="element-252" />
        </div>

        <div data-id="element-253">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-254">
            Option Value <span className="text-red-500" data-id="element-255">*</span>
          </label>
          <input type="text" required value={formData.optionValue || ''} onChange={e => setFormData({
          ...formData,
          optionValue: e.target.value
        })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500 sm:text-sm font-mono text-gray-600" placeholder="e.g., SingleFamily" data-id="element-256" />
        </div>

        <div className="grid grid-cols-2 gap-4" data-id="element-257">
          <div data-id="element-258">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-259">
              Display Order
            </label>
            <input type="number" min="1" value={formData.order || 1} onChange={e => setFormData({
            ...formData,
            order: parseInt(e.target.value) || 1
          })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500 sm:text-sm" data-id="element-260" />
          </div>

          <div className="flex items-center pt-6" data-id="element-261">
            <label className="flex items-center cursor-pointer" data-id="element-262">
              <div className="relative" data-id="element-263">
                <input type="checkbox" className="sr-only" checked={formData.active ?? true} onChange={e => setFormData({
                ...formData,
                active: e.target.checked
              })} data-id="element-264" />
                <div className={`block w-10 h-6 rounded-full transition-colors ${formData.active ? 'bg-green-500' : 'bg-gray-300'}`} data-id="element-265"></div>
                <div className={`absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition-transform ${formData.active ? 'transform translate-x-4' : ''}`} data-id="element-266"></div>
              </div>
              <span className="ml-3 text-sm font-medium text-gray-700" data-id="element-267">
                Active
              </span>
            </label>
          </div>
        </div>
      </form>
    </Modal>;
}